module.exports = __webpack_public_path__ + "img/Bodice-Front-B2-Cb-Jd.f33a3e90.png";